import React from "react";
import PropTypes from "prop-types";
import { isEmpty } from "lodash";
import styled from "styled-components";

import View from "../styled/View";
import Map from "../common/Map";
import { PhoneNumber as phoneNumber } from "../../helpers";

const formatAddress = (address = {}) =>
  [
    address.addr1,
    address.addr2,
    address.city,
    address.state?.value,
    address.country?.value,
    address.zip
  ]
    .filter(Boolean)
    .join(", ");

const CustomerView = ({ customer }) => {
  let data = {};
  if (!isEmpty(customer)) {
    data = {
      "Customer Number": customer.number,
      Name: customer.name,
      Phone: phoneNumber(customer.phone),
      Address: formatAddress(customer.address),
      Fax: customer.fax,
      Website: customer.website
    };
  }

  return (
    <CustomerViewStyles>
      <div className="content-wrapper">
        <fieldset>
          <legend>Customer Info</legend>
        </fieldset>
        <div className="data-container">
          {Object.keys(data).map((key, i) => {
            if (key === "Website") {
              return (
                <div key={i} className="data">
                  <label htmlFor="website">{key}</label>
                  <a
                    id="website"
                    href={data[key]}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {data[key]}
                  </a>
                </div>
              );
            }
            if (key === "Phone") {
              return (
                <div key={i} className="data">
                  <label htmlFor="phone">{key}</label>
                  <a
                    id="phone"
                    href={`tel:${data[key]}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {data[key]}
                  </a>
                </div>
              );
            }

            return (
              <div key={i} className="data">
                <label htmlFor={key}>{key}</label>
                <span id={key}>{data[key]}</span>
              </div>
            );
          })}
        </div>
      </div>
      <div className="content-wrapper">
        <div className="map-container">
          {customer && customer.address && <Map address={customer.address} />}
        </div>
      </div>
    </CustomerViewStyles>
  );
};

const CustomerViewStyles = styled(View)`
  grid-template-columns: 1fr 2fr;
  grid-template-areas:
    "data data data"
    "map map map";
  & > .content-wrapper:first-child {
    min-height: 30vh;
  }

  .map-container {
    grid-area: map;
    & > div {
      border-radius: 5px;
      height: auto !important;
      margin: 0 !important;
      position: absolute;
      bottom: 0;
      right: 0;
      left: 0;
      top: 0;
    }
  }

  @media screen and (max-width: 769px) {
    margin: 0 5px;
    grid-template-columns: 1fr;
    grid-template-areas:
      "data"
      "map";
    .content-wrapper:nth-child(2) {
      display: none;
    }
  }
`;

CustomerView.propTypes = {
  customer: PropTypes.object.isRequired
};

export default CustomerView;
